import { Component, ElementRef, OnInit } from '@angular/core';
import { NavigationService } from 'app-components';
import moment from 'moment';
import { AppSettingsService } from 't4-app-integration';
import { CampaignInfo, PageBase } from 't4core';

@Component({
  selector: 'app-campaign-details',
  templateUrl: './campaign-details.html',
  styleUrls: ['./campaign-details.css'],
  standalone: false
})
export class CampaignDetailsComponent extends PageBase implements OnInit {

  public campaign: CampaignInfo;
  public isLoading: boolean = false;
  public qrcodeUri: string = "";
  public activatedAt: string = "";



  constructor(
    el: ElementRef,
    public appSettings: AppSettingsService,
    private navigationService: NavigationService
  ) {
    super(el);
  }

  async ngOnInit() {
    this.isLoading = true;

    if (this.navigationService.getParam('discountCode')) {
      var discountCode = this.navigationService.getParam('discountCode');
      this.campaign = await this.Api.get<CampaignInfo>("/Campaign/GetCampaignOfferInfo", { discountId: discountCode })

      this.setBackground(this.campaign.LogoType.Uri);
      /* if (this.campaign.ActivatedAt) this.activatedAt = this.campaign.ActivatedAt;*/

      var response = await this.Api.get<string>("/Campaign/ActivatePartnerCampaign", { discountCode: this.campaign.DiscountCode })

      var urlRegex = /^https?:\/\/[^\s/$.?#].[^\s]*$/;
      if (urlRegex.test(response)) {
        this.qrcodeUri = response;
        this.activatedAt = new Date().getTime().toString();

      }
      else if (response = "1") {
        this.activatedAt = new Date().getTime().toString();
      }
      else {
        this.UI.alert("Intellitrailer.MyPage.CampaignCard.ErrorActivation.Headline", "Error!", "Intellitrailer.MyPage.CampaignCard.ErrorActivation.Message_" + response, response);
        this.navigationService.executeCommand("Back");
      }


    }
    this.isLoading = false;
  }


  setBackground(uri: string) {
    const circleElements = document.querySelectorAll<HTMLLIElement>('.circles li');

    // Loop through each li element and set the background image
    circleElements.forEach((liElement) => {
      liElement.style.backgroundImage = `url(${uri})`;
    });
  }

}
